<app-temp-modal-cadastro #modalDadosDeclaracao modalContentId="modal-dados-declaracao"
  textHeader="Documento Importação" (closed)="onClose()" [customClass]="'modal-lg'">
  <form [formGroup]="form">
    <div class="row">
      <div class="form-group col-sm-6">
        <label for="form_ndi" class="label-required">Número do Documento de Importação</label>
        <input id="form_ndi" type="text" class="form-control" formControlName="ndi" maxlength="15" />
        <show-errors [control]="form.controls.ndi"></show-errors>
      </div>
      <div class="form-group col-sm-6">
        <label for="form_ddi" class="label-required">Data de Registro</label>
        <app-data [calendarPosition]="'left'" formControlName="ddi">
        </app-data>
        <show-errors [control]="form.controls.ddi"></show-errors>
      </div>
      <div class="form-group col-sm-6">
        <label for="form_xLocDesemb" class="label-required">Local de desembaraço</label>
        <input id="form_xLocDesemb" type="text" class="form-control" formControlName="xLocDesemb" maxlength="60" />
        <show-errors [control]="form.controls.xLocDesemb"></show-errors>
      </div>
      <div class="form-group col-sm-6">
        <label for="form_ufDesemb" class="label-required">UF de desembaraço</label>
        <input id="form_ufDesemb" type="text" class="form-control" formControlName="ufDesemb" maxlength="2" />
        <show-errors [control]="form.controls.ufDesemb"></show-errors>
      </div>
      <div class="form-group col-sm-6">
        <label for="form_dDesemb" class="label-required">Data do desembaraço</label>
        <app-data [calendarPosition]="'left'" formControlName="dDesemb">
        </app-data>
        <show-errors [control]="form.controls.dDesemb"></show-errors>
      </div>
      <div class="form-group col-sm-6">
        <label for="form_tipoViaTransporte" class="label-required">Tipo Via de Transporte</label>
        <ng-select [items]="listaTipoViaTransporte" bindValue="value" bindLabel="label"
          formControlName="tipoViaTransporte" [clearable]="false">
        </ng-select>
        <show-errors [control]="form.controls.tipoViaTransporte"></show-errors>
      </div>
      <div class="form-group col-sm-6">
        <label for="form_valorAFRMM" [class.label-required]="fieldRequired('valorAFRMM')">Valor AFRMM</label>
        <input id="form_valorAFRMM" type="text" class="form-control" formControlName="valorAFRMM"
          currencyMask [options]="{ precision: 2, allowNegative: false }" />
        <show-errors [control]="form.controls.valorAFRMM"></show-errors>
      </div>
      <div class="form-group col-sm-6">
        <label for="form_formaImportacao" class="label-required">Forma de Importação</label>
        <ng-select [items]="listaFormaImportacao" bindValue="value" bindLabel="label" formControlName="formaImportacao"
          [clearable]="false">
        </ng-select>
        <show-errors [control]="form.controls.formaImportacao"></show-errors>
      </div>
      <div class="form-group col-sm-6" rem5 combobox [type]="'cliente'" formControlName="clienteID"
        [label]="'Adquirente/Encomendante'" [form]="form" appendTo="#modal-dados-declaracao">
      </div>
      <div class="form-group col-sm-6">
        <label for="form_cExportador" class="label-required">Código do Exportador</label>
        <input id="form_cExportador" type="text" class="form-control" formControlName="cExportador" maxlength="60" />
        <show-errors [control]="form.controls.cExportador"></show-errors>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col">
        <h5>Adição</h5>
        <hr>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-sm-6">
        <label for="form_nAdicao" class="label-required">Número da Adição</label>
        <input id="form_nAdicao" type="text" class="form-control" formControlName="nAdicao" maxlength="3" />
        <show-errors [control]="form.controls.nAdicao"></show-errors>
      </div>
      <div class="form-group col-sm-6">
        <label for="form_nSeqAdic" class="label-required">Número sequencial do item</label>
        <input id="form_nSeqAdic" type="text" class="form-control" formControlName="nSeqAdic" maxlength="5" />
        <show-errors [control]="form.controls.nSeqAdic"></show-errors>
      </div>
      <div class="form-group col-sm-6">
        <label for="form_cFabricante" class="label-required">Código do Fabricante</label>
        <input id="form_cFabricante" type="text" class="form-control" formControlName="cFabricante" maxlength="60" />
        <show-errors [control]="form.controls.cFabricante"></show-errors>
      </div>
      <div class="form-group col-sm-6">
        <label for="form_vDescDI">Valor do desconto</label>
        <input id="form_vDescDI" type="text" class="form-control" formControlName="vDescDI"
          currencyMask [options]="{ precision: 2, allowNegative: false }" />
        <show-errors [control]="form.controls.vDescDI"></show-errors>
      </div>
      <div class="form-group col-sm-6">
        <label for="form_nDraw">Número Drawback</label>
        <input id="form_nDraw" type="text" class="form-control" formControlName="nDraw" />
        <show-errors [control]="form.controls.nDraw"></show-errors>
      </div>
    </div>
  </form>

  <div class="m-t-20">
    <button class="btn btn-primary" (click)="salvar()" [disabled]="loading['salvar']">
      <i class="fa fa-save"></i> Salvar
    </button>
    <button class="btn btn-info" (click)="cancelar()" [disabled]="loading['salvar']">
      Cancelar
    </button>
  </div>
</app-temp-modal-cadastro>